// // static code
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./LaunchParatha.css";
// const PRODUCTS = [
//   {
//     id: "ln-1",
//     name: "Shabnam Cotton Silk Saree",
//     price: 3999,
//     oldPrice: 5950,
//     images: [
//       "/img/scrollsec3.webp",
//       "/img/scrollsec4.webp",
//     ],
//     // images: ["/images/launch1.jpg", "/images/launch1-hover.jpg"],
//     // link: "/products?category=2&subcategory=1",
//     link: "/launch-product/ln-1", 
//   },
//   {
//     id: "ln-2",
//     name: "Ruhira Maheshwari Cotton Saree",
//     price: 3850,
//     oldPrice: 5549,
//     images: [
//       "/img/scrollsec1.webp",
//       "/img/scrollsec2.webp",
//     ],
//     // images: ["/images/launch2.jpg", "/images/launch2-hover.jpg"],
//     // link: "/products?category=2&subcategory=2",
//     link: "/launch-product/ln-2", 
//   },
//   {
//     id: "ln-3",
//     name: "Gulmohar Maheshwari Cotton Silk Saree",
//     price: 3899,
//     oldPrice: 5500,
//     images: [
//       "/img/scrollsec5.webp",
//       "/img/scrollsec6.webp",
//     ],
//     // images: ["/images/launch3.jpg", "/images/launch3-hover.jpg"],
//     // link: "/products?category=2&subcategory=3",
//     link: "/launch-product/ln-3", 
//   },
//   {
//     id: "ln-4",
//     name: "Nazrana Maheshwari Cotton Silk Saree",
//     price: 3899,
//     oldPrice: 5500,
//     images: [
//       "/img/scrollsec7.webp",
//       "/img/scrollsec8.webp",
//     ],
//     // images: ["/images/launch4.jpg", "/images/launch4-hover.jpg"],
//     // link: "/products?category=2&subcategory=4",
//     link: "/launch-product/ln-4", 
//   },
//   {
//     id: "ln-5",
//     name: "Gulrang Maheshwari Cotton Silk Saree",
//     price: 3899,
//     oldPrice: 5500,
//     images: [
//       "/img/scrollsec9.webp",
//       "/img/scrollsec10.webp",
//     ],
//     // images: ["/images/launch4.jpg", "/images/launch4-hover.jpg"],
//     // link: "/products?category=2&subcategory=5",
//     link: "/launch-product/ln-5", 
//   },
// ];

// /* View All button kahan le jaye */
// const VIEW_ALL_PATH = "/products";

// const formatPrice = (value) =>
//   `Rs. ${Number(value).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   })}`;

// /* ---------------------------- ICONS ---------------------------- */
// const PlusIcon = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
//     <path d="M12 5v14M5 12h14" />
//   </svg>
// );

// const MinusIcon = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
//     <path d="M5 12h14" />
//   </svg>
// );

// const ChevronIcon = ({ dir = "right" }) => (
//   <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: dir === "left" ? "scaleX(-1)" : "none" }}>
//     <path d="M9 5l7 7-7 7" />
//   </svg>
// );

// const CloseIcon = () => (
//   <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
//     <path d="M5 5l14 14M19 5L5 19" />
//   </svg>
// );

// /* --------------------------- COMPONENT -------------------------- */
// const LaunchParatha = () => {
//   const navigate = useNavigate();

//   const [canPrev, setCanPrev] = useState(false);
//   const [canNext, setCanNext] = useState(false);

//   const [cartOpen, setCartOpen] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [showNote, setShowNote] = useState(false);
//   const [orderNote, setOrderNote] = useState("");

//   const trackRef = useRef(null);
//   const headerRef = useRef(null);

//   /* ---------------- Carousel arrows state ---------------- */
//   const updateArrows = useCallback(() => {
//     const el = trackRef.current;
//     if (!el) return;
//     setCanPrev(el.scrollLeft > 4);
//     setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
//   }, []);

//   useEffect(() => {
//     updateArrows();
//     window.addEventListener("resize", updateArrows);
//     return () => window.removeEventListener("resize", updateArrows);
//   }, [updateArrows]);

//   const scrollByPage = (direction) => {
//     const el = trackRef.current;
//     if (!el) return;
//     el.scrollBy({ left: direction * (el.clientWidth + 24), behavior: "smooth" });
//   };

//   /* ---------------- Heading fade-in on scroll ---------------- */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("launchparatha-animate-in");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     if (headerRef.current) observer.observe(headerRef.current);
//     return () => observer.disconnect();
//   }, []);

//   /* ---------------- Cart drawer ---------------- */
//   // Body scroll lock + Esc se close
//   useEffect(() => {
//     if (!cartOpen) return;
//     const prevOverflow = document.body.style.overflow;
//     document.body.style.overflow = "hidden";
//     const onKey = (e) => e.key === "Escape" && setCartOpen(false);
//     document.addEventListener("keydown", onKey);
//     return () => {
//       document.body.style.overflow = prevOverflow;
//       document.removeEventListener("keydown", onKey);
//     };
//   }, [cartOpen]);

//   /* Plus button click: product cart mein add + drawer open.
//      Real cart API se jodna ho to yahan apna add-to-cart call laga dena. */
//   const handleAddToCart = (product) => {
//     setCartItems((prev) => {
//       const exists = prev.find((item) => item.id === product.id);
//       if (exists) {
//         return prev.map((item) =>
//           item.id === product.id ? { ...item, qty: item.qty + 1 } : item
//         );
//       }
//       return [
//         ...prev,
//         {
//           id: product.id,
//           name: product.name,
//           price: product.price,
//           image: product.images[0],
//           qty: 1,
//         },
//       ];
//     });
//     setCartOpen(true);
//   };

//   const changeQty = (id, delta) => {
//     setCartItems((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, qty: Math.max(1, item.qty + delta) } : item
//       )
//     );
//   };

//   const removeItem = (id) => {
//     setCartItems((prev) => prev.filter((item) => item.id !== id));
//   };

//   const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);

//   const handleCheckout = () => {
//     setCartOpen(false);
//     navigate("/bag");
//   };

//   return (
//     <section className="launchparatha-section">
//       <div className="launchparatha-container">
//         {/* Heading */}
//         <div className="launchparatha-header" ref={headerRef}>
//           <p className="launchparatha-subtitle">Our Most Loved Picks</p>
//           <h2 className="launchparatha-title">New Launches</h2>
//         </div>

//         {/* Carousel */}
//         <div className="launchparatha-carousel">
//           <button
//             type="button"
//             className={`launchparatha-arrow launchparatha-arrow-prev ${
//               canPrev ? "launchparatha-arrow-show" : ""
//             }`}
//             aria-label="Previous products"
//             onClick={() => scrollByPage(-1)}
//             tabIndex={canPrev ? 0 : -1}
//           >
//             <ChevronIcon dir="left" />
//           </button>

//           <div className="launchparatha-track" ref={trackRef} onScroll={updateArrows}>
//             {PRODUCTS.map((product) => (
//               <article className="launchparatha-card" key={product.id}>
//                 <div className="launchparatha-media">
//                   <Link
//                     to={product.link}
//                     className="launchparatha-media-link"
//                     aria-label={product.name}
//                   >
//                     <img
//                       src={product.images[0]}
//                       alt={product.name}
//                       className="launchparatha-img launchparatha-img-main"
//                       loading="lazy"
//                       draggable={false}
//                     />
//                     {product.images[1] && (
//                       <img
//                         src={product.images[1]}
//                         alt=""
//                         className="launchparatha-img launchparatha-img-hover"
//                         loading="lazy"
//                         draggable={false}
//                       />
//                     )}
//                   </Link>

//                   <button
//                     type="button"
//                     className="launchparatha-plus"
//                     aria-label={`Add ${product.name} to cart`}
//                     onClick={() => handleAddToCart(product)}
//                   >
//                     <PlusIcon />
//                   </button>
//                 </div>

//                 <Link to={product.link} className="launchparatha-info">
//                   <h3 className="launchparatha-name">{product.name}</h3>
//                   <p className="launchparatha-price">
//                     <span>{formatPrice(product.price)}</span>
//                     <s>{formatPrice(product.oldPrice)}</s>
//                   </p>
//                 </Link>
//               </article>
//             ))}
//           </div>

//           <button
//             type="button"
//             className={`launchparatha-arrow launchparatha-arrow-next ${
//               canNext ? "launchparatha-arrow-show" : ""
//             }`}
//             aria-label="Next products"
//             onClick={() => scrollByPage(1)}
//             tabIndex={canNext ? 0 : -1}
//           >
//             <ChevronIcon dir="right" />
//           </button>
//         </div>

//         {/* View All */}
//         <div className="launchparatha-viewall-wrap">
//           <Link to={VIEW_ALL_PATH} className="launchparatha-viewall">
//             View All
//           </Link>
//         </div>
//       </div>

//       {/* ---------------- CART DRAWER ---------------- */}
//       <div
//         className={`launchparatha-overlay ${cartOpen ? "launchparatha-open" : ""}`}
//         onClick={() => setCartOpen(false)}
//         aria-hidden={!cartOpen}
//       />

//       <aside
//         className={`launchparatha-drawer ${cartOpen ? "launchparatha-open" : ""}`}
//         aria-label="Cart"
//         aria-hidden={!cartOpen}
//       >
//         <div className="launchparatha-drawer-head">
//           <h4>Cart</h4>
//           <button
//             type="button"
//             className="launchparatha-drawer-close"
//             aria-label="Close cart"
//             onClick={() => setCartOpen(false)}
//             tabIndex={cartOpen ? 0 : -1}
//           >
//             <CloseIcon />
//           </button>
//         </div>

//         <div className="launchparatha-drawer-body">
//           {cartItems.length === 0 ? (
//             <p className="launchparatha-empty">Your cart is empty.</p>
//           ) : (
//             cartItems.map((item) => (
//               <div className="launchparatha-cart-item" key={item.id}>
//                 <img src={item.image} alt={item.name} />

//                 <div className="launchparatha-cart-info">
//                   <p className="launchparatha-cart-name">{item.name}</p>
//                   <p className="launchparatha-cart-price">{formatPrice(item.price)}</p>

//                   <div className="launchparatha-cart-actions">
//                     <div className="launchparatha-qty">
//                       <button
//                         type="button"
//                         aria-label="Decrease quantity"
//                         onClick={() => changeQty(item.id, -1)}
//                         tabIndex={cartOpen ? 0 : -1}
//                       >
//                         <MinusIcon />
//                       </button>
//                       <span>{item.qty}</span>
//                       <button
//                         type="button"
//                         aria-label="Increase quantity"
//                         onClick={() => changeQty(item.id, 1)}
//                         tabIndex={cartOpen ? 0 : -1}
//                       >
//                         <PlusIcon />
//                       </button>
//                     </div>

//                     <button
//                       type="button"
//                       className="launchparatha-remove"
//                       onClick={() => removeItem(item.id)}
//                       tabIndex={cartOpen ? 0 : -1}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>

//         <div className="launchparatha-drawer-foot">
//           <button
//             type="button"
//             className="launchparatha-note-toggle"
//             onClick={() => setShowNote((p) => !p)}
//             tabIndex={cartOpen ? 0 : -1}
//           >
//             Add order note
//           </button>

//           {showNote && (
//             <textarea
//               className="launchparatha-note"
//               rows={3}
//               placeholder="Write your note here..."
//               value={orderNote}
//               onChange={(e) => setOrderNote(e.target.value)}
//             />
//           )}

//           <p className="launchparatha-tax">Taxes and shipping calculated at checkout</p>

//           <div className="launchparatha-subtotal">
//             <strong>Subtotal:</strong>
//             <strong>{formatPrice(subtotal)}</strong>
//           </div>

//           <button
//             type="button"
//             className="launchparatha-checkout"
//             onClick={handleCheckout}
//             disabled={cartItems.length === 0}
//             tabIndex={cartOpen ? 0 : -1}
//           >
//             Checkout
//           </button>
//         </div>
//       </aside>
//     </section>
//   );
// };

// export default LaunchParatha;












// Dynamic code
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./LaunchParatha.css";

/* ⚠️ Yahan apna asli API endpoint daalo */
const API_URL = "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_new_launches"; // <-- apna endpoint yahan

/* View All button kahan le jaye */
// const VIEW_ALL_PATH = "/products";

/* View All button kahan le jaye */
const VIEW_ALL_PATH = "/all-sarees";

const formatPrice = (value) =>
  `Rs. ${Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/* API item -> card ka shape (baaki code same rehta hai) */
const mapProduct = (item) => {
  const hover = Array.isArray(item.hover_image_urls) ? item.hover_image_urls[0] : null;
  const images = [item.image_url];
  if (hover) images.push(hover);

  return {
    id: String(item.id),
    name: item.heading,
    price: Number(item.current_price),
    oldPrice: Number(item.old_price),
    images,
    // link: `/launch-product/${item.id}`,
    link: item.product_slug ? `/product/${item.product_slug}` : "/all-sarees",
  };
};

/* ---------------------------- ICONS ---------------------------- */
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const MinusIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
    <path d="M5 12h14" />
  </svg>
);

const ChevronIcon = ({ dir = "right" }) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: dir === "left" ? "scaleX(-1)" : "none" }}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
    <path d="M5 5l14 14M19 5L5 19" />
  </svg>
);

/* --------------------------- COMPONENT -------------------------- */
const LaunchParatha = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [showNote, setShowNote] = useState(false);
  const [orderNote, setOrderNote] = useState("");

  const trackRef = useRef(null);
  const headerRef = useRef(null);

  /* ---------------- API fetch ---------------- */
  useEffect(() => {
    const controller = new AbortController();

    const fetchLaunches = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(API_URL, { signal: controller.signal });
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();

        const ok = json?.success === "1" || json?.success === 1 || json?.status === "true" || json?.status === true;
        if (!ok || !Array.isArray(json.data)) {
          throw new Error(json?.message || "Failed to load launches");
        }

        // A -> B logic: admin se jo pehla add hua wo pehle card par
        const sorted = [...json.data].sort((a, b) => Number(a.id) - Number(b.id));
        setProducts(sorted.map(mapProduct));
      } catch (err) {
        if (err.name !== "AbortError") {
          setError("Something went wrong while loading new launches.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchLaunches();
    return () => controller.abort();
  }, []);

  /* ---------------- Carousel arrows state ---------------- */
  const updateArrows = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateArrows();
    window.addEventListener("resize", updateArrows);
    return () => window.removeEventListener("resize", updateArrows);
  }, [updateArrows, products]); // products load hone ke baad arrows dobara calculate

  const scrollByPage = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * (el.clientWidth + 24), behavior: "smooth" });
  };

  /* ---------------- Heading fade-in on scroll ---------------- */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("launchparatha-animate-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  /* ---------------- Cart drawer ---------------- */
  // Body scroll lock + Esc se close
  useEffect(() => {
    if (!cartOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && setCartOpen(false);
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [cartOpen]);

  /* Plus button click: product cart mein add + drawer open.
     Real cart API se jodna ho to yahan apna add-to-cart call laga dena. */
  const handleAddToCart = (product) => {
    setCartItems((prev) => {
      const exists = prev.find((item) => item.id === product.id);
      if (exists) {
        return prev.map((item) =>
          item.id === product.id ? { ...item, qty: item.qty + 1 } : item
        );
      }
      return [
        ...prev,
        {
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          qty: 1,
        },
      ];
    });
    setCartOpen(true);
  };

  const changeQty = (id, delta) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: Math.max(1, item.qty + delta) } : item
      )
    );
  };

  const removeItem = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);

  const handleCheckout = () => {
    setCartOpen(false);
    navigate("/bag");
  };

  return (
    <section className="launchparatha-section">
      <div className="launchparatha-container">
        {/* Heading (static) */}
        <div className="launchparatha-header" ref={headerRef}>
          <p className="launchparatha-subtitle">Our Most Loved Picks</p>
          <h2 className="launchparatha-title">New Launches</h2>
        </div>

        {/* Loading / Error / Empty */}
        {loading && <p className="launchparatha-empty">Loading...</p>}
        {!loading && error && <p className="launchparatha-empty">{error}</p>}
        {!loading && !error && products.length === 0 && (
          <p className="launchparatha-empty">No new launches available.</p>
        )}

        {/* Carousel */}
        {!loading && !error && products.length > 0 && (
          <div className="launchparatha-carousel">
            <button
              type="button"
              className={`launchparatha-arrow launchparatha-arrow-prev ${
                canPrev ? "launchparatha-arrow-show" : ""
              }`}
              aria-label="Previous products"
              onClick={() => scrollByPage(-1)}
              tabIndex={canPrev ? 0 : -1}
            >
              <ChevronIcon dir="left" />
            </button>

            <div className="launchparatha-track" ref={trackRef} onScroll={updateArrows}>
              {products.map((product) => (
                <article className="launchparatha-card" key={product.id}>
                  <div className="launchparatha-media">
                    <Link
                      to={product.link}
                      className="launchparatha-media-link"
                      aria-label={product.name}
                    >
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        className="launchparatha-img launchparatha-img-main"
                        loading="lazy"
                        draggable={false}
                      />
                      {product.images[1] && (
                        <img
                          src={product.images[1]}
                          alt=""
                          className="launchparatha-img launchparatha-img-hover"
                          loading="lazy"
                          draggable={false}
                        />
                      )}
                    </Link>

                    <button
                      type="button"
                      className="launchparatha-plus"
                      aria-label={`Add ${product.name} to cart`}
                      onClick={() => handleAddToCart(product)}
                    >
                      <PlusIcon />
                    </button>
                  </div>

                  <Link to={product.link} className="launchparatha-info">
                    <h3 className="launchparatha-name">{product.name}</h3>
                    <p className="launchparatha-price">
                      <span>{formatPrice(product.price)}</span>
                      <s>{formatPrice(product.oldPrice)}</s>
                    </p>
                  </Link>
                </article>
              ))}
            </div>

            <button
              type="button"
              className={`launchparatha-arrow launchparatha-arrow-next ${
                canNext ? "launchparatha-arrow-show" : ""
              }`}
              aria-label="Next products"
              onClick={() => scrollByPage(1)}
              tabIndex={canNext ? 0 : -1}
            >
              <ChevronIcon dir="right" />
            </button>
          </div>
        )}

        {/* View All */}
        <div className="launchparatha-viewall-wrap">
          <Link to={VIEW_ALL_PATH} className="launchparatha-viewall">
            View All
          </Link>
        </div>
      </div>

      {/* ---------------- CART DRAWER ---------------- */}
      <div
        className={`launchparatha-overlay ${cartOpen ? "launchparatha-open" : ""}`}
        onClick={() => setCartOpen(false)}
        aria-hidden={!cartOpen}
      />

      <aside
        className={`launchparatha-drawer ${cartOpen ? "launchparatha-open" : ""}`}
        aria-label="Cart"
        aria-hidden={!cartOpen}
      >
        <div className="launchparatha-drawer-head">
          <h4>Cart</h4>
          <button
            type="button"
            className="launchparatha-drawer-close"
            aria-label="Close cart"
            onClick={() => setCartOpen(false)}
            tabIndex={cartOpen ? 0 : -1}
          >
            <CloseIcon />
          </button>
        </div>

        <div className="launchparatha-drawer-body">
          {cartItems.length === 0 ? (
            <p className="launchparatha-empty">Your cart is empty.</p>
          ) : (
            cartItems.map((item) => (
              <div className="launchparatha-cart-item" key={item.id}>
                <img src={item.image} alt={item.name} />

                <div className="launchparatha-cart-info">
                  <p className="launchparatha-cart-name">{item.name}</p>
                  <p className="launchparatha-cart-price">{formatPrice(item.price)}</p>

                  <div className="launchparatha-cart-actions">
                    <div className="launchparatha-qty">
                      <button
                        type="button"
                        aria-label="Decrease quantity"
                        onClick={() => changeQty(item.id, -1)}
                        tabIndex={cartOpen ? 0 : -1}
                      >
                        <MinusIcon />
                      </button>
                      <span>{item.qty}</span>
                      <button
                        type="button"
                        aria-label="Increase quantity"
                        onClick={() => changeQty(item.id, 1)}
                        tabIndex={cartOpen ? 0 : -1}
                      >
                        <PlusIcon />
                      </button>
                    </div>

                    <button
                      type="button"
                      className="launchparatha-remove"
                      onClick={() => removeItem(item.id)}
                      tabIndex={cartOpen ? 0 : -1}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="launchparatha-drawer-foot">
          <button
            type="button"
            className="launchparatha-note-toggle"
            onClick={() => setShowNote((p) => !p)}
            tabIndex={cartOpen ? 0 : -1}
          >
            Add order note
          </button>

          {showNote && (
            <textarea
              className="launchparatha-note"
              rows={3}
              placeholder="Write your note here..."
              value={orderNote}
              onChange={(e) => setOrderNote(e.target.value)}
            />
          )}

          <p className="launchparatha-tax">Taxes and shipping calculated at checkout</p>

          <div className="launchparatha-subtotal">
            <strong>Subtotal:</strong>
            <strong>{formatPrice(subtotal)}</strong>
          </div>

          <button
            type="button"
            className="launchparatha-checkout"
            onClick={handleCheckout}
            disabled={cartItems.length === 0}
            tabIndex={cartOpen ? 0 : -1}
          >
            Checkout
          </button>
        </div>
      </aside>
    </section>
  );
};

export default LaunchParatha;